import React, { useEffect, useState } from 'react';

const mapSymbolToId = (symbol) => {
  const mapping = {
    BTC: 'bitcoin',
    ETH: 'ethereum',
    XRP: 'ripple',
    BNB: 'binancecoin',
    ADA: 'cardano',
    ETC: 'ethereum-classic',
    SOL: 'solana',
    SHIB: 'shiba-inu',
    DOT: 'polkadot',
    ICP: 'internet-computer',
    ACH: 'alchemy-pay',
  };
  return mapping[symbol.toUpperCase()];
};

const OptionPopup = ({
  initialDuration = 30,
  countdown: countdownProp,
  direction,
  selectedCoin,
  purchaseQty,
  entryPrice,
  onComplete,
  selectedTimeOption,
}) => {
  const radius = 90;
  const circumference = 2 * Math.PI * radius;

  // Always use the passed countdown prop for perfect sync
  const countdown =
    countdownProp !== undefined ? countdownProp : initialDuration;
  const [priceUp, setPriceUp] = useState(true);
  const [displayPrice, setDisplayPrice] = useState(
    entryPrice ? entryPrice.toFixed(2) : null
  );

  useEffect(() => {
    let realPrice = null;
    let lastFakePrice = entryPrice || null;
    let intervalReal, intervalFake;

    const fetchRealPrice = async () => {
      try {
        const base = selectedCoin?.symbol?.split('/')[0].toLowerCase();
        const id = mapSymbolToId(base);
        const res = await fetch(
          `https://api.coingecko.com/api/v3/simple/price?ids=${id}&vs_currencies=usd`
        );
        const data = await res.json();
        realPrice = data[id]?.usd || 0;
        lastFakePrice = realPrice;
        setDisplayPrice(realPrice.toFixed(2));
      } catch (err) {}
    };

    const simulateFluctuation = () => {
      if (lastFakePrice === null) return;
      const fakeChange = (Math.random() - 0.5) * 1.5; // simulate ±0.75 change
      const newPrice = parseFloat((lastFakePrice + fakeChange).toFixed(2));
      setPriceUp(newPrice >= lastFakePrice); // update green/red
      lastFakePrice = newPrice;
      setDisplayPrice(newPrice.toFixed(2));
    };

    fetchRealPrice(); // Initial real price
    intervalReal = setInterval(fetchRealPrice, 5000); // update every 5s
    intervalFake = setInterval(simulateFluctuation, 200); // simulate every 0.2s

    return () => {
      clearInterval(intervalReal);
      clearInterval(intervalFake);
    };
  }, [selectedCoin, entryPrice]);

  const progress = (1 - countdown / initialDuration) * circumference;
  const rewardPercent = selectedTimeOption?.reward?.replace('%', '') || 30;
  const gain = ((purchaseQty * rewardPercent) / 100).toFixed(2);
  const loss = gain;

  return (
    <div
      className='position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center'
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', zIndex: 1060 }}
    >
      <div
        className='rounded shadow text-white text-center p-4'
        style={{ width: '300px', background: '#111', borderRadius: '1rem' }}
      >
        <h5 className='mb-2 text-white'>CONFIRM</h5>

        <div
          style={{
            fontSize: '18px',
            fontWeight: 'bold',
            marginBottom: '5px',
            color: priceUp ? '#00ff00' : '#ff4d4d',
          }}
        >
          ${displayPrice || '...'}
        </div>

        <h1
          className='fw-bold mb-3'
          style={{ fontSize: '3rem', animation: 'pulseCountdown 1s infinite' }}
        >
          {Math.floor(countdown / 3600)
            .toString()
            .padStart(2, '0')}
          :
          {Math.floor((countdown % 3600) / 60)
            .toString()
            .padStart(2, '0')}
          :{(countdown % 60).toString().padStart(2, '0')}
        </h1>

        <svg width='200' height='200' viewBox='0 0 200 200'>
          <circle
            cx='100'
            cy='100'
            r='90'
            stroke='#333'
            strokeWidth='12'
            fill='none'
          />
          <circle
            cx='100'
            cy='100'
            r='90'
            stroke={direction === 'Long' ? '#28a745' : '#dc3545'}
            strokeWidth='12'
            fill='none'
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            transform='rotate(-90 100 100)'
          />
          <foreignObject x='50' y='70' width='100' height='80'>
            <div
              xmlns='http://www.w3.org/1999/xhtml'
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              <img
                src={require(`../assets/coins/${selectedCoin?.symbol
                  ?.split('/')[0]
                  .toLowerCase()}.png`)}
                alt='icon'
                width={30}
                height={30}
                style={{ marginBottom: 5 }}
              />
              <div>{selectedCoin?.symbol}</div>
            </div>
          </foreignObject>
        </svg>

        <div className='mt-3'>
          <div className='text-success'>+{gain} USDT</div>
          <div className='text-danger'>-{loss} USDT</div>
        </div>
      </div>

      <style>{`
        @keyframes pulseCountdown {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default OptionPopup;
